import { computed, Injectable } from "@angular/core";
import { ArticleInfos } from "../../models/article.model";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { ArticlesInfosFacadeService } from "./article-infos-facade.service";

@Injectable({ providedIn: "root" })
export class ArticlesInfosStoreService extends EntityStoreService<
  ArticleInfos,
  EntityMetadata,
  ArticleInfosState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
    });
  }

  getByArticleId(articleId: string) {
    if (!articleId) {
      return computed(() => null);
    }
    return computed(() =>
      this.allEntities().find((e) => e.articleId === articleId) ?? null
    );
  }

  getByCode(code: string) {
    return computed(() =>
      this.allEntities().find((e) => e.code === code) ?? null
    );
  }

  getByEAN14(ean14: string) {
    if (!ean14) {
      throw new Error("ean14 null");
    }
    return computed(() =>
      this.allEntities().find((e) => e.ean14 === ean14) ?? null
    );
  }
}

export interface ArticleInfosState
  extends EntityStoreState<ArticlesInfosFacadeService> {}
